<ts-resource-editor [resource]="resource$ | async" [embedInCard]="true" (submitted)="back()"></ts-resource-editor>
